export enum NotificationEventType {
    ObjectAdded = 'ObjectAdded',
    ObjectUpdated = 'ObjectUpdated',
    ObjectDeleted = 'ObjectDeleted',
}
